function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import t from "../common/base-provider.js";
import { newInAppMessageFromJson as ut } from "../InAppMessage/in-app-message-factory.js";
import ve from "../models/braze-event.js";
import { isArray as z, isEqual as ii, validateValueIsFromEnum as ta } from "../util/code-utils.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import wt from "../InAppMessage/models/templated-in-app-message.js";
import pt from "./models/trigger.js";
import et from "./models/trigger-events.js";
import { logger as N } from "../../shared-lib/index.js";

var gr = /*#__PURE__*/function (_t) {
  _inherits(gr, _t);

  var _super = _createSuper(gr);

  function gr(t, i, s, e, r) {
    var _this;

    _classCallCheck(this, gr);

    _this = _super.call(this), _this.tg = t, _this.Ts = i, _this.C = s, _this.Fi = e, _this.ig = r, _this.tg = t, _this.Ts = i, _this.C = s, _this.Fi = e, _this.ig = r, _this.sg = [], _this.eg = [], _this.hg = null, _this.ng = {}, _this.og = {}, _this.triggers = [], _this.lg = 0, _this.ag(), _this.gg();
    return _this;
  }

  _createClass(gr, [{
    key: "fg",
    value: function fg() {
      if (this.C) {
        this.hg = this.C.ft(s.gt.aE) || this.hg, this.ng = this.C.ft(s.gt.iE) || this.ng, this.og = this.C.ft(s.gt.nE) || this.og;

        for (var _t2 = 0; _t2 < this.triggers.length; _t2++) {
          var i = this.triggers[_t2];
          i.id && null != this.og[i.id] && i.ad(this.og[i.id]);
        }
      }
    }
  }, {
    key: "ag",
    value: function ag() {
      if (!this.C) return;
      this.lg = this.C.ft(s.gt.oE) || 0;
      var t = this.C.ft(s.gt.rE) || [],
          i = [];

      for (var _s = 0; _s < t.length; _s++) {
        i.push(pt.Rn(t[_s]));
      }

      this.triggers = i, this.fg();
    }
  }, {
    key: "gg",
    value: function gg() {
      var t = this,
          i = function i(_i, s, e, r, h) {
        return function () {
          t.cg(_i, s, e, r, h);
        };
      },
          e = {};

      var _iterator = _createForOfIteratorHelper(this.triggers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t7 = _step.value;
          _t7.id && (e[_t7.id] = _t7);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var r = !1;

      for (var _t3 = 0; _t3 < this.triggers.length; _t3++) {
        var _s2 = this.triggers[_t3];

        if (_s2.id && null != this.ng[_s2.id]) {
          var _t4 = this.ng[_s2.id],
              h = [];

          for (var _r = 0; _r < _t4.length; _r++) {
            var n = _t4[_r],
                o = _s2.ud(n.Hr || 0);

            if (o > 0) {
              var _t5 = void 0,
                  _r2 = void 0;

              h.push(n), null != n.ug && (_t5 = n.ug), null != n.dg && ve.RE(n.dg) && (_r2 = ve.Rn(n.dg));
              var l = [];
              if (n.pg && z(n.pg)) for (var _t6 = 0; _t6 < n.pg.length; _t6++) {
                var _i2 = e[n.pg[_t6]];
                null != _i2 && l.push(_i2);
              }
              this.eg.push(window.setTimeout(i(_s2, n.Hr || 0, _t5, _r2, l), o));
            }
          }

          this.ng[_s2.id].length > h.length && (this.ng[_s2.id] = h, r = !0, 0 === this.ng[_s2.id].length && delete this.ng[_s2.id]);
        }
      }

      r && this.C && this.C.Bt(s.gt.iE, this.ng);
    }
  }, {
    key: "mg",
    value: function mg() {
      if (!this.C) return;
      var t = [];

      for (var i = 0; i < this.triggers.length; i++) {
        t.push(this.triggers[i].bt());
      }

      this.lg = new Date().valueOf(), this.C.Bt(s.gt.rE, t), this.C.Bt(s.gt.oE, this.lg);
    }
  }, {
    key: "bg",
    value: function bg() {
      if (!this.C) return;
      (this.C.ft(s.gt.oE) || 0) > this.lg ? this.ag() : this.fg();
    }
  }, {
    key: "U",
    value: function U(t) {
      var i = !1;

      if (null != t && t.triggers) {
        this.ig.Yr(), this.fg();
        var e = {},
            r = {};
        this.triggers = [];

        for (var _s3 = 0; _s3 < t.triggers.length; _s3++) {
          var _h = pt.fromJson(t.triggers[_s3]);

          if (_h) {
            _h.id && null != this.og[_h.id] && (_h.ad(this.og[_h.id]), e[_h.id] = this.og[_h.id]), _h.id && null != this.ng[_h.id] && (r[_h.id] = this.ng[_h.id]);

            for (var _t8 = 0; _t8 < _h.sd.length; _t8++) {
              if (_h.sd[_t8]._c(et.As, null)) {
                i = !0;
                break;
              }
            }

            this.triggers.push(_h);
          }
        }

        ii(this.og, e) || (this.og = e, this.C && this.C.Bt(s.gt.nE, this.og)), ii(this.ng, r) || (this.ng = r, this.C && this.C.Bt(s.gt.iE, this.ng)), this.mg(), i && (N.info("Trigger with test condition found, firing test."), this.Ce(et.As)), this.Ce(et.OPEN);
        var h = this.sg;
        var n;
        this.sg = [];

        for (var _t9 = 0; _t9 < h.length; _t9++) {
          n = Array.prototype.slice.call(h[_t9]), this.Ce.apply(this, _toConsumableArray(n));
        }
      }
    }
  }, {
    key: "cg",
    value: function cg(t, i, s, e, r) {
      var _this2 = this;

      var h = function h(e) {
        _this2.fg();

        var r = new Date().valueOf();
        t.dd(i) || (!1 === navigator.onLine && t.type === pt.Or.Cr && e.imageUrl ? N.info("Not showing ".concat(t.type, " trigger action ").concat(t.id, " due to offline state.")) : t.nd(r) && _this2.wg(t, r, s) ? 0 === _this2.Ts.hc() ? N.info("Not displaying trigger ".concat(t.id, " because neither automaticallyShowInAppMessages() nor subscribeToInAppMessage() were called.")) : (_this2.Ts.X([e]), _this2.yg(t, r)) : N.info("Not displaying trigger ".concat(t.id, " because display time fell outside of the acceptable time window.")));
      },
          n = function n() {
        _this2.fg();

        var h = r.pop();
        if (null != h) if (_this2.Tg(h, i, s, e, r), h.dd(i)) {
          var _t10 = "Server aborted in-app message display, but the timeout on fallback trigger ".concat(h.id, " has already elapsed.");

          r.length > 0 && (_t10 += " Continuing to fall back."), N.info(_t10), n();
        } else {
          N.info("Server aborted in-app message display. Falling back to lower priority ".concat(h.type, " trigger action ").concat(t.id, "."));

          var _n = 1e3 * h.ed - (new Date().valueOf() - i);

          _n > 0 ? _this2.eg.push(window.setTimeout(function () {
            _this2.cg(h, i, s, e, r);
          }, _n)) : _this2.cg(h, i, s, e, r);
        }
      };

      var o, l, a;

      switch (t.type) {
        case pt.Or.Cr:
          if (o = ut(t.data), null == o) {
            N.error("Could not parse trigger data for trigger ".concat(t.id, ", ignoring."));
            break;
          }

          if (l = this.ig.Ir(o), l) {
            N.error(l), n();
            break;
          }

          h(o);
          break;

        case pt.Or.md:
          if (a = wt.fromJson(t.data, h, n, i, t.Jr || 0), null == a) {
            N.error("Could not parse trigger data for trigger ".concat(t.id, ", ignoring."));
            break;
          }

          this.ig.qr(a, s, e);
          break;

        default:
          N.error("Trigger ".concat(t.id, " was of unexpected type ").concat(t.type, ", ignoring."));
      }
    }
  }, {
    key: "Ce",
    value: function Ce(t) {
      var _this3 = this;

      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var s = arguments.length > 2 ? arguments[2] : undefined;
      if (!ta(et, t, "Cannot fire trigger action.", "TriggerEvents")) return;
      if (this.Fi && this.Fi.dc()) return N.info("Trigger sync is currently in progress, awaiting sync completion before firing trigger event."), void this.sg.push(arguments);
      this.bg();
      var e = new Date().valueOf(),
          r = e - (this.hg || 0);
      var h = !0,
          n = !0;
      var o = [];

      for (var _s4 = 0; _s4 < this.triggers.length; _s4++) {
        var _r3 = this.triggers[_s4],
            _l = e + 1e3 * _r3.ed;

        if (_r3.nd(_l) && (null == _r3.startTime || _r3.startTime.valueOf() <= e) && (null == _r3.endTime || _r3.endTime.valueOf() >= e)) {
          var _s5 = !1;

          for (var _e = 0; _e < _r3.sd.length; _e++) {
            if (_r3.sd[_e]._c(t, i)) {
              _s5 = !0;
              break;
            }
          }

          _s5 && (h = !1, this.wg(_r3, _l, t) && (n = !1, o.push(_r3)));
        }
      }

      if (h) return void N.info("Trigger event ".concat(t, " did not match any trigger conditions."));
      if (n) return void N.info("Ignoring ".concat(t, " trigger event because a trigger was displayed ").concat(r / 1e3, "s ago."));
      o.sort(function (t, i) {
        return t.priority - i.priority;
      });
      var l = o.pop();
      null != l && (N.info("Firing ".concat(l.type, " trigger action ").concat(l.id, " from trigger event ").concat(t, ".")), this.Tg(l, e, t, s, o), 0 === l.ed ? this.cg(l, e, t, s, o) : this.eg.push(window.setTimeout(function () {
        _this3.cg(l, e, t, s, o);
      }, 1e3 * l.ed)));
    }
  }, {
    key: "changeUser",
    value: function changeUser() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;

      if (this.triggers = [], this.C && this.C.Ut(s.gt.rE), !t) {
        this.sg = [], this.hg = null, this.og = {}, this.ng = {};

        for (var _t11 = 0; _t11 < this.eg.length; _t11++) {
          clearTimeout(this.eg[_t11]);
        }

        this.eg = [], this.C && (this.C.Ut(s.gt.aE), this.C.Ut(s.gt.nE), this.C.Ut(s.gt.iE));
      }
    }
  }, {
    key: "clearData",
    value: function clearData() {
      this.triggers = [], this.hg = null, this.og = {}, this.ng = {};

      for (var _t12 = 0; _t12 < this.eg.length; _t12++) {
        clearTimeout(this.eg[_t12]);
      }

      this.eg = [];
    }
  }, {
    key: "wg",
    value: function wg(t, i, s) {
      if (null == this.hg) return !0;
      if (s === et.As) return N.info("Ignoring minimum interval between trigger because it is a test type."), !0;
      var e = t.hd;
      return null == e && (e = this.tg), i - this.hg >= 1e3 * e;
    }
  }, {
    key: "Tg",
    value: function Tg(t, i, e, r, h) {
      this.fg(), t.id && (this.ng[t.id] = this.ng[t.id] || []);
      var n = {};
      var o;
      n.Hr = i, n.ug = e, null != r && (o = r.bt()), n.dg = o;
      var l = [];

      var _iterator2 = _createForOfIteratorHelper(h),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _t13 = _step2.value;
          _t13.id && l.push(_t13.id);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      n.pg = l, t.id && this.ng[t.id].push(n), this.C && this.C.Bt(s.gt.iE, this.ng);
    }
  }, {
    key: "yg",
    value: function yg(t, i) {
      this.fg(), t.ad(i), this.hg = i, t.id && (this.og[t.id] = i), this.C && (this.C.Bt(s.gt.aE, i), this.C.Bt(s.gt.nE, this.og));
    }
  }]);

  return gr;
}(t);

export { gr as default };